import { render, staticRenderFns } from "./product_list.vue?vue&type=template&id=5ec8d413&scoped=true"
import script from "./product_list.vue?vue&type=script&lang=js"
export * from "./product_list.vue?vue&type=script&lang=js"
import style0 from "./product_list.vue?vue&type=style&index=0&id=5ec8d413&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec8d413",
  null
  
)

export default component.exports